import { signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { Subscription } from 'rxjs';

import { ExportJobId } from '../models/export-data.type';

import { fileExportComputed } from './file-export.computed';
import { fileExportDataAdapterMethodsFactory } from './file-export.data-adapter-methods';

export type FileManagerListItem = {
  id: ExportJobId['jobId'];
  name: string;
  status: 'pending' | 'completed' | 'failed';
  subscription: Subscription;
  queryParams?: Record<string, string>;
};

type FileState = {
  files: Array<FileManagerListItem>;
};

export type FileExportState = FileState;

const initialState: FileExportState = { files: [] };

export const FileExportStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods(fileExportDataAdapterMethodsFactory),
  withComputed(fileExportComputed),
);
